import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import MultiLineInput from 'components/MultiLineInput';

class EditPanel extends PureComponent {
    handleKeyDown = event => {
        if (event.which === 27) {
            this.cancel();
        }

        if (event.which === 13) {
            if (!this.props.autoUpdate) {
                this.submit();
            }
        }
    }

    handleSubmitClick = () => {
        requestAnimationFrame(() => {
            this.submit();
        });
    }

    handleCloseClick = () => {
        this.cancel();
    }

    handleCancelClick = () => {
        this.cancel();
    }

    handleBlur = nextValue => {
        if (this.canceled) {
            return;
        }

        this.value = nextValue;

        if (!this.props.autoUpdate) {
            return;
        }

        this.submit();
    }

    handleFocus = () => {
        this.canceled = false;
    }

    submit() {
        if (this.value !== '') {
            this.props.onSubmit(this.value);
        }
    }

    cancel() {
        this.canceled = true;
        this.props.onCancel && this.props.onCancel();
    }

    render() {
        const { t } = this.props;

        return (
            <div className={'edit-panel' + (this.props.autoHeight ? ' auto-height' : '')}>
                {
                    (!this.props.noClose || this.props.title) ?  (
                        <div className="edit-panel-head">
                            {
                                this.props.title ? (
                                    <h4 className="edit-panel-title">{this.props.title}</h4>
                                ) : null
                            }

                            {
                                !this.props.noClose ? (
                                    <button className="btn edit-panel-close" onClick={this.handleCloseClick}>
                                        <i className="ion ion-close-round" />
                                    </button>
                                ) : null
                            }
                        </div>
                    ) : null
                }

                <div className="edit-panel-body">
                    <MultiLineInput
                        className="edit-panel-input"
                        canEdit={true}
                        autoFocus={this.props.autoFocus}
                        value={this.props.defaultValue}
                        placeholder={this.props.placeholder}
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                        onKeyDown={this.handleKeyDown}
                    />
                </div>

                {
                    !this.props.autoUpdate ? (
                        <div className="edit-panel-foot">
                            <div className="btn-group">
                                <button className="btn btn-small btn-simple" onClick={this.handleCancelClick}>{ t('Cancel') }</button>

                                <button className="btn btn-small btn-success" onClick={this.handleSubmitClick}>{this.props.actionText}</button>
                            </div>
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

export default withTranslation('common')(EditPanel);
